import { render, staticRenderFns } from "./Groupe.vue?vue&type=template&id=8e797af6&scoped=true"
import script from "./Groupe.vue?vue&type=script&lang=js"
export * from "./Groupe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e797af6",
  null
  
)

export default component.exports